import { render, staticRenderFns } from "./DepartmentPickerDialog.vue?vue&type=template&id=edc697da&scoped=true"
import script from "./DepartmentPickerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPickerDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentPickerDialog.vue?vue&type=style&index=0&id=edc697da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc697da",
  null
  
)

export default component.exports